export interface MapBounds {
  north: number;
  south: number;
  east: number;
  west: number;
}

export const TYPESENSE_GEOLOC_FIELD = 'geoloc';

/**
 * Typesense polygon filter for a rectangular map viewport.
 * Corner order: SW → SE → NE → NW (Typesense geosearch polygon).
 */
export function buildTypesenseBoundingBoxGeoFilter(
  bounds: MapBounds,
  field = TYPESENSE_GEOLOC_FIELD,
): string {
  const { north, south, east, west } = bounds;
  const pairs = [south, west, south, east, north, east, north, west];
  return `${field}:(${pairs.join(', ')})`;
}

/**
 * Algolia `insideBoundingBox`: [[south, west, north, east]].
 */
export function buildTypesenseGeoFilterFromAlgoliaInsideBoundingBox(
  insideBoundingBox: number[][],
  field = TYPESENSE_GEOLOC_FIELD,
): string | undefined {
  const box = insideBoundingBox[0];
  if (!box || box.length < 4) return undefined;
  const [south, west, north, east] = box;
  if (
    ![south, west, north, east].every((n) => typeof n === 'number' && Number.isFinite(n))
  ) {
    return undefined;
  }
  return buildTypesenseBoundingBoxGeoFilter({ south, west, north, east }, field);
}
